/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import i18n from '@/i18n'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: i18n.t('id'),
    tableConfig: {
      align: 'start'
    }
  },
  operateType: {
    displayName: 'operateType'
  },
  operateName: {
    displayName: 'operateName'
  },
  createdAt: {
    type: IKDataEntity.Types.Date,
    displayName: 'TimeStamp'
  }
}
const config = {
  load: async function (filter) {
    return (await hillo.get('AccessLog.php', {
      op: 'getAllRecords', ...filter
    })).content
  }
}

export default IKDataEntity.ModelFactory(entity, config)
